import { useParams } from "react-router-dom";
import { selectUsername } from "selectors/User";
import { useYearFilter } from "model/Filter/TournamentFilters";
import { UserPicksFilters } from "components/FilterPanels/UserPicksFilters";
import { useTournamentPickemFilter } from "model/Filter/PickemFilters";
import { selectTournamentIdFromName } from "selectors/Tournament";
import { ErrorMessagePage, SingleColumnPage } from "pages/PageTemplates";
import { PickemUserPageContent } from "./PickemUserPageContent";
import { TournamentLoader } from "pages/TournamentLoader";
import { useAppSelector } from "app/hooks";

export const PickemUserPage = () => {
  const { uid } = useParams();
  const username = useAppSelector((state) => selectUsername(state, uid));

  const yearFilter = useYearFilter(false);
  const selectedYear = yearFilter.selectedValue;
  const tournamentFilter = useTournamentPickemFilter(
    selectedYear,
    "Comic Con Baltics 2025"
  );
  const selectedTournament = tournamentFilter.selectedValue;

  const tournamentId = useAppSelector((state) =>
    selectTournamentIdFromName(state, selectedTournament)
  );

  if (!uid || !username) {
    return <ErrorMessagePage message="Unable to find user" />;
  }

  return (
    <SingleColumnPage>
      <UserPicksFilters
        yearFilter={yearFilter}
        tournamentFilter={tournamentFilter}
        header={`${username}'s Picks`}
      />
      {!tournamentId ? (
        <ErrorMessagePage message="Unable to find tournament" />
      ) : (
        <TournamentLoader tournamentIds={[tournamentId]}>
          <PickemUserPageContent uid={uid} tournamentId={tournamentId} />
        </TournamentLoader>
      )}
    </SingleColumnPage>
  );
};
